export default __webpack_public_path__ + "static/media/Food.51f913e7.svg";